// extracted by mini-css-extract-plugin
export default {"main":"IconButton_main__ZVw2p","disabled":"IconButton_disabled__PY5cR"};